import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons/index';
import { getTimeInfoUi, getJobTimeDurationUi } from '../../../../helpers/jobs';
import { dayMonthDate } from '../../../../constants/date';

export default class ShortSummary extends Component {
  static propTypes = {
    isSecondStepFilled: PropTypes.func.isRequired,
    isThirdStepFilled: PropTypes.func.isRequired,
    jobSkillData: PropTypes.shape({
      icon_url: PropTypes.string.isRequired,
      skill_label: PropTypes.string.isRequired
    }),
    description: PropTypes.string.isRequired,
    locationLabel: PropTypes.string.isRequired,
    jobsList: PropTypes.arrayOf(
      PropTypes.shape({
        start: PropTypes.object.isRequired,
        startTime: PropTypes.object.isRequired,
        endTime: PropTypes.object.isRequired,
        hours: PropTypes.number.isRequired,
        quantityOfWorkers: PropTypes.number.isRequired
      })
    ),
    hoursSum: PropTypes.number.isRequired,
    estCostSum: PropTypes.string.isRequired
  };

  render () {
    const { isSecondStepFilled, isThirdStepFilled, jobSkillData, jobsList, description, locationLabel, hoursSum,
      estCostSum } = this.props;
    return (
      <div className='job-details-sum-wrapper'>
        {isSecondStepFilled() && (
          <div className='skill-cost-info'>
            <div className='header-left'>
              <div
                className='job-image'
                style={{ backgroundImage: `url('${jobSkillData.icon_url}')` }}
              />
              <h5 className='job-title'>{jobSkillData.skill_label}</h5>
            </div>
            <div className='header-right'>
              <h5 className='est-cost-item'>{ estCostSum }</h5>
              <p className='text-muted'>Est. Pay</p>
            </div>
          </div>
        )}
        { isThirdStepFilled() && (
          <p className='job-description'>{description}</p>
        )}
        <div className='job-details-sum'>
          <p title={locationLabel} className='text-muted location-item py-2'>
            <span className='icon-wrapper'><FontAwesomeIcon icon={faMapMarkerAlt} /></span>
            {locationLabel}
          </p>
          <div className='py-2'>
            <p className='text-muted'>Dates</p>
            { jobsList.map(job => (
              <div key={job.id} className='row py-1'>
                <p className='col-4'>{ moment(job.start).format(dayMonthDate) }</p>
                <div className='col-2'>
                  <div className='workers-quantity-circle'>
                    { job.quantityOfWorkers }
                  </div>
                </div>
                <p className='col-6'>{ getTimeInfoUi(job.startTime, job.endTime, job.hours) }</p>
              </div>
            ))}
          </div>
          <div className='py-2'>
            <p className='text-muted'>Total Estimate Hours</p>
            <div className='d-flex justify-content-between'>
              <p>{ getJobTimeDurationUi(hoursSum) }</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/createJob/createJob/ShortSummary.js